import React, { useState } from "react";
import ResizableHeader from "./headers/resizable.header.table.component";

const DEFAULT_COLUMNS = [
  {
    id: "id",
    label: "DEFAULT COL",
    editable: false,
    dropdownOptions: null,
    width: 150,
  },
];

function Table({
  columns = DEFAULT_COLUMNS,
  sortProps = { sort: "", handleSort: () => {} },
  select = false,
  handleSelectAll = () => {},
  selectAll,
  children,
}) {
  const [colWidths, setColWidths] = useState({});
  const handleResize = (index, newWidth) => {
    const updatedWidths = { ...colWidths };
    updatedWidths[index] = newWidth;
    setColWidths(updatedWidths);
  };

  return (
    <div
      style={{ height: "calc(100vh - 136px)" }}
      className="overflow-x-auto h-full border bg-slate-100 rounded px-1 pb-8"
    >
      <table className="border-separate">
        <thead className="z-30 bg-slate-200 sticky top-0">
          <tr>
            {select && (
              <th className="max-w-[45px]">
                <input
                  className="checked:accent-primary w-[45px]"
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectAll}
                />
              </th>
            )}
            {columns
              .filter((column) => (column?.show ? column : null))
              .map((column, index) => (
                <ResizableHeader
                  key={index}
                  select={select}
                  index={index}
                  text={column.label}
                  onResize={handleResize}
                >
                  <div
                    className={`active:drop-shadow-textShadow active:skew-y-0 hover:skew-y-2 hover:cursor-pointer hover:text-primary `}
                    style={{
                      width: `${colWidths?.[index] || column?.width}px`,
                    }}
                    onClick={() => sortProps?.handleSort(column.id)}
                  >
                    {column.label}
                  </div>
                </ResizableHeader>
              ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export default Table;
